module.exports = __webpack_public_path__ + "static/rustlogo140-f3ed465ff873161c6334365e1128a048.png";